import {
  convertApiParams,
  createDeleteRequest,
  createPatchRequest,
  createPostRequest,
  createPutRequest,
} from './apiHelpers';

export const API_TYPES_MAP = {
  assessments: 'item-labels',
  video: 'resource-labels',
};

const createLabelAPI = async (label) =>
  createPostRequest({
    url: `/assessments/api/labels/`,
    params: convertApiParams(label),
  });

const updateLabelAPI = async (label) =>
  createPatchRequest({
    url: `/assessments/api/labels/${label.labelId}/`,
    params: convertApiParams(label),
  });

const deleteLabelAPI = async ({ labelId }) =>
  createDeleteRequest({ url: `/assessments/api/labels/${labelId}/` });

const createLabelItemAssociation = async ({ labelId, resourceId }) =>
  createPostRequest({
    url: `/assessments/api/item-labels/`,
    params: { label_id: labelId, item_id: resourceId },
  });

const createLabelResourceAssociation = async ({ labelId, resourceId }) =>
  createPostRequest({
    url: `/assessments/api/resource-labels/`,
    params: { label_id: labelId, resource_id: resourceId },
  });

const createLabelItemAssociationsBulk = async ({
  quizId = null,
  labelIds = [],
}) =>
  createPutRequest({
    url: `/assessments/api/item-labels/bulk/${quizId}`,
    params: { label_ids: labelIds },
  });

const createLabelResourceAssociationsBulk = async ({
  resourceId = null,
  labelIds = [],
}) =>
  createPutRequest({
    url: `/assessments/api/resource-labels/bulk/${resourceId}`,
    params: { label_ids: labelIds },
  });

const updateLabelsVisibilityAPI = async (studentVisible, masterSubjectId) =>
  createPutRequest({
    url: '/assessments/api/labels/student_visible/',
    params: convertApiParams({ studentVisible, masterSubjectId }),
  });

const updateLabelAssociationsBulkAPI = async (type, resourceId, label_ids) =>
  createPutRequest({
    url: `/assessments/api/${API_TYPES_MAP[type]}/bulk/${resourceId}`,
    params: { label_ids },
  });

const addMultipleLabelResourcesBulk = async ({
  resourceIds = [],
  labelIds = [],
}) =>
  createPutRequest({
    url: `/assessments/api/resource-labels/bulk/`,
    params: { label_ids: labelIds, resource_ids: resourceIds },
  });

const addMultipleLabelItemsBulk = async ({ itemIds = [], labelIds = [] }) =>
  createPutRequest({
    url: `/assessments/api/item-labels/bulk/`,
    params: { label_ids: labelIds, item_ids: itemIds },
  });

const reorderLabelsAPI = async (label_ids) =>
  createPatchRequest({
    url: `/assessments/api/labels/reorder/`,
    params: { label_ids },
  });

export {
  createLabelAPI,
  updateLabelAPI,
  deleteLabelAPI,
  createLabelItemAssociation,
  createLabelResourceAssociation,
  createLabelItemAssociationsBulk,
  createLabelResourceAssociationsBulk,
  updateLabelsVisibilityAPI,
  updateLabelAssociationsBulkAPI,
  addMultipleLabelItemsBulk,
  addMultipleLabelResourcesBulk,
  reorderLabelsAPI,
};
